import { createContext } from 'react';

const DocumentValuesContext = createContext({
  cfi: null,
  percentageScrolled: null,
  state: null,
  frame: null,
  frameContainer: null,
  frameDocument: null,
});

export default DocumentValuesContext;
